// Event names match the revex ES indices verbatim (incl. the `communites` typo).
export const PAGE_HIT = {
  CLIENTPORTAL: 'clientportal_user_page_hit',
  GOKOLLAB: 'gokollab_user_page_hit',
  COMMUNITIES: 'communites_user_page_hit', // [sic]
  COURSES: 'courses_learner_page_hit',
} as const

export type PageHitEvent = (typeof PAGE_HIT)[keyof typeof PAGE_HIT]

export function resolveAppFlavor(appName: unknown): string {
  const normalized = typeof appName === 'string' ? appName.trim().toLowerCase() : ''
  return normalized || 'clientportal'
}

// Match on path OR route name — gokollab serves communities/courses under slugs (no /communities path).
export function resolveEventTypes(path: string, routeName: string | undefined, isGokollab: boolean): PageHitEvent[] {
  const name = routeName ?? ''
  const isCommunities = path.startsWith('/communities') || name.includes('communities')
  const isCourses = path.startsWith('/courses') || name.includes('courses')

  const events: PageHitEvent[] = [PAGE_HIT.CLIENTPORTAL]
  if (isGokollab) events.push(PAGE_HIT.GOKOLLAB)
  if (isCommunities) events.push(PAGE_HIT.COMMUNITIES)
  if (isCourses) events.push(PAGE_HIT.COURSES)
  return events
}

// /account appends its active tab so each tab counts as a distinct page.
export function buildTrackedRoute(path: string, activeTab?: string): string {
  return path === '/account' && activeTab ? `${path}-${activeTab}` : path
}
